import { lazy, Suspense, useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';

// Use the same rem media query as Tailwind lg, including browser font settings.
const desktopMedia = '(min-width: 64rem)';
const snapshot = () => window.matchMedia(desktopMedia).matches;
const subscribe = (listener: () => void) => {
  const media = window.matchMedia(desktopMedia);
  media.addEventListener('change', listener);
  return () => media.removeEventListener('change', listener);
};

function QrUnavailable() {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      className="grid size-24 place-items-center text-center text-caption text-gp-ink-600"
    >
      {t('brand.qrUnavailable')}
    </div>
  );
}

// Optional artwork failure must not break the app or repeat inside RouteError.
const DesktopQrCode = lazy(() =>
  import('./DesktopQrCode').catch(() => ({ default: QrUnavailable })),
);

export default function DesktopQrCodeGate({ value }: { value: string }) {
  const desktop = useSyncExternalStore(subscribe, snapshot, () => false);
  if (!desktop) return null;
  return (
    <Suspense fallback={<div className="size-24" aria-hidden="true" />}>
      <DesktopQrCode value={value} />
    </Suspense>
  );
}
